import React, { useState } from 'react';
import { DateTimePicker } from 'components/LegacyPickers';
import jMoment from 'moment-jalaali';
import { DatePickerPod, SimpleDialog, Icons } from 'components';
import { Button, Grid, Typography } from '@mui/material';
import persianJs from 'persianjs';
import { useStyles } from './FilterDateRangeStyle';
import { enifyDateTime } from 'utility';

const FilterDateTimeRange = ({
  onFilterChanged,
  defaultStartDate = null,
  defaultEndDate = null,
  columnDef,
  ...rest
}) => {
  const initDates = {
    startDateTime: {
      date: '',
      time: '',
    },
    endDateTime: {
      date: '',
      time: '',
    },
  };
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [dateFilter, setDateFilter] = useState({
    startDateTime: {
      date: defaultStartDate ? enifyDateTime(defaultStartDate?.format('jYYYY/jMM/jDD')) : '',
      time: defaultStartDate ? enifyDateTime(defaultStartDate?.format('HH:mm:ss')) : '',
    },
    endDateTime: {
      date: defaultEndDate ? enifyDateTime(defaultEndDate?.format('jYYYY/jMM/jDD')) : '',
      time: defaultEndDate ? enifyDateTime(defaultEndDate?.format('HH:mm:ss')) : '',
    },
  });
  const [openDialog, setOpenDialog] = useState(false);
  const classes = useStyles();

  const handleChangeStart = (e) => {
    setStartDate(e);
    if (!e) {
      setDateFilter({ ...initDates });
      return;
    }
    setDateFilter((prev) => ({
      ...prev,
      startDateTime: {
        date: jMoment(e)?.format('jYYYY/jMM/jDD') ?? null,
        time: jMoment(e)?.format('HH:mm:ss') ?? null,
      },
    }));
  };

  const handleChangeEnd = (e) => {
    setEndDate(e);
    if (!e) {
      setDateFilter({ ...initDates });
      return;
    }
    setDateFilter((prev) => ({
      ...prev,
      endDateTime: {
        date: jMoment(e)?.format('jYYYY/jMM/jDD') ?? null,
        time: jMoment(e)?.format('HH:mm:ss') ?? null,
      },
    }));
  };

  const handleResetFilter = () => {
    handleChangeStart(null);
    handleChangeEnd(null);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    submitDialog(true);
  };

  const submitDialog = (resetFilter) => {
    setOpenDialog(false);
    const reset = resetFilter === true && (!defaultStartDate || !defaultEndDate);
    if (reset) {
      handleResetFilter();
    }
    const enDateFilter = { ...dateFilter };

    enDateFilter.startDateTime.date = enDateFilter.startDateTime?.date
      ? persianJs(enDateFilter.startDateTime.date).toEnglishNumber().toString()
      : null;
    enDateFilter.startDateTime.time = enDateFilter.startDateTime?.time
      ? persianJs(enDateFilter.startDateTime.time).toEnglishNumber().toString()
      : null;

    enDateFilter.endDateTime.date = enDateFilter.endDateTime?.date
      ? persianJs(enDateFilter.endDateTime.date).toEnglishNumber().toString()
      : null;
    enDateFilter.endDateTime.time = enDateFilter.endDateTime?.time
      ? persianJs(enDateFilter.endDateTime.time).toEnglishNumber().toString()
      : null;

    onFilterChanged(columnDef.tableData.id, reset ? null : enDateFilter);
  };

  const openDialogRange = () => {
    const newDate = new Date();
    const date = jMoment(newDate).format('jYYYY/jMM/jDD');
    const time = jMoment(newDate).format('HH:mm:ss');
    const dateObj = {};

    if (!dateFilter?.startDateTime?.date) {
      dateObj.startDateTime = {
        date,
        time,
      };
    } else {
      dateObj.startDateTime = dateFilter?.startDateTime;
    }

    if (!dateFilter?.endDateTime?.date) {
      dateObj.endDateTime = {
        date,
        time,
      };
    } else {
      dateObj.endDateTime = dateFilter?.endDateTime;
    }

    setDateFilter(dateObj);

    setOpenDialog(true);
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button variant="contained" color="primary" onClick={submitDialog}>
          اعمال
        </Button>

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>

        {!defaultStartDate || !defaultStartDate ? (
          <Button
            startIcon={<Icons icon="Trash" color="#2b3990" size="20" />}
            variant="contained"
            style={{ marginInlineStart: 'auto', marginInlineEnd: 8 }}
            onClick={() => {
              submitDialog(true);
            }}
          >
            حذف فیلتر
          </Button>
        ) : null}
      </>
    );
  };

  return (
    <>
      <Button
        fullWidth
        onClick={() => openDialogRange()}
        variant="outlined"
        className={classes.defaultLabelButton}
      >
        {startDate ? 'از ' : null}
        {startDate?.format('jYYYY/jMM/jDD HH:mm:ss')} {startDate && endDate ? 'تا ' : null}
        {endDate?.format('jYYYY/jMM/jDD HH:mm:ss')}
        {!startDate && !endDate ? 'انتخاب بازه' : null}
      </Button>

      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={openDialog}
        title="انتخاب بازه تاریخی "
        onClose={handleCloseDialog}
        actions={<ActionsBtn />}
      >
        <Grid container alignItems="center" justifyContent="center" spacing={3}>
          <Grid item xs={6}>
            <Typography color="textSecondary" gutterBottom>
              از تاریخ:
            </Typography>
            <DatePickerPod>
              <DateTimePicker
                {...rest}
                autoOk
                inputVariant="outlined"
                showTodayButton
                todayLabel="امروز"
                okLabel="تایید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD HH:mm:ss') : '')}
                value={startDate ?? null}
                onChange={handleChangeStart}
                disableFuture
              />
            </DatePickerPod>
          </Grid>
          <Grid item xs={6}>
            <Typography color="textSecondary" gutterBottom>
              تا تاریخ:
            </Typography>
            <DatePickerPod>
              <DateTimePicker
                {...rest}
                autoOk
                inputVariant="outlined"
                todayLabel="امروز"
                okLabel="تایید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD HH:mm:ss') : '')}
                value={endDate}
                onChange={handleChangeEnd}
                disableFuture
                {...(startDate
                  ? {
                    minDate: startDate,
                  }
                  : {})}
              />
            </DatePickerPod>
          </Grid>
        </Grid>
      </SimpleDialog>
    </>
  );
};


export default FilterDateTimeRange;
